import { Box, Grid, Paper, Stack, Typography } from '@mui/material';

import { type ZeitlicherAblauf, type Zeitraum } from '../../../../../dtos';
import { formatTimeRangeForDate } from '../../../../../utils';
import { DatePickerWrapper } from '../../../DatePickerWrapper';
import { inferAblaufFromStartDate } from '../../VivaRessourcenCalendars.utils';

type AblaufCardProps = {
  readonly ablauf: Zeitraum[];
  readonly onAblaufChange: (ablauf: Zeitraum[]) => void;
  readonly zeitlicherAblauf: ZeitlicherAblauf;
};

export const AblaufCard = ({ ablauf, onAblaufChange, zeitlicherAblauf }: AblaufCardProps) => {
  const handleBeginDateChange = (value: Date | null): void => {
    if (value === null) {
      return;
    }

    onAblaufChange(inferAblaufFromStartDate(value, zeitlicherAblauf));
  };

  const renderAblauf = (): React.ReactNode => {
    if (ablauf.length === 0) {
      return '-';
    }

    return ablauf.map((zeitraum) => (
      <div key={zeitraum.start.getTime()}>
        <Typography>{formatTimeRangeForDate(zeitraum.start, zeitraum.end)}</Typography>
      </div>
    ));
  };

  return (
    <Paper sx={{ padding: 3 }}>
      <Grid container>
        <Grid size={{ xs: 6 }}>
          <Stack direction="column" spacing={3} sx={{ width: 'fit-content' }}>
            <Typography variant="labelLight" color="textTertiary">
              Gib den Veranstaltungsbeginn an
            </Typography>
            {/* eslint-disable-next-line @eslint-react/purity -- added during migration to ban-pdk. please solve issue or explain disable-reason here */}
            <DatePickerWrapper label="Veranstaltungsbeginn" onChange={handleBeginDateChange} minDate={new Date()} />
          </Stack>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Stack direction="column" spacing={3}>
            <Typography variant="labelLight" color="textTertiary">
              Ablauf
            </Typography>
            <Box>{renderAblauf()}</Box>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};
